/* ---------------------------------------------------------------
   Kuno · Ergaenzungsschicht · 29.08.2026
   Laedt NACH kuno-suche.js und VOR kuno-render.js.

   Zehn Korrekturen aus dem Test vom 29.08.2026. Der Grundsatz aus
   der Suchschicht gilt weiter: gepruefter Code wird nicht
   umgeschrieben, sondern ueberlagert. Faellt diese Datei aus, steht
   der Stand vom 27.08. unveraendert da.

   Drin sind:
   1  Naehrwerte aus dem Shop nachgezogen: 10 belegte Zuckerwerte
      waren im Schnappschuss, 75 stehen in Shopify.
   2  Zucker als eigene Antwort - Chip statt Olivensorte.
   3  Die vier Fachbuecher, die bisher in keiner Antwort auftauchten.
   4  Rezepte gemischt statt 22 Eistees am Stueck.
   5  Vergleich auch fuer Olivenoel, nicht nur fuer Honig.

   Nachtrag 29.08., zweite Runde. Alexander: "Bringe auch die anderen
   Werte dahin, dass die auch mit angezeigt werden und mit reinlaufen."
   Also nicht nur Zucker: Energie, Fett, gesaettigte Fettsaeuren,
   Kohlenhydrate und Eiweiss kommen aus denselben Shop-Metafeldern und
   liegen jetzt vollstaendig in NAEHRWERT. Damit beantwortet Kuno
   "Wie viel Eiweiss hat X" und "Wie viel Fett sind in 30 g Y" von
   selbst - die Funktionen dafuer gab es laengst, ihnen fehlten nur
   die Zahlen.
   --------------------------------------------------------------- */
(function () {
  'use strict';
  if (typeof PRODUKTE === 'undefined') return;
  if (window.KUNO_EXTRA) return;
  window.KUNO_EXTRA = '2026-08-29';

  var B = 'https://cdn.shopify.com/s/files/1/0961/6336/5203/files/';

  /* ============================================================
     1 · Naehrwerte nachtragen
     NAEHRWERT ist ein Objekt im gemeinsamen Bereich und laesst sich
     erweitern. Vorhandene Eintraege bleiben, wie sie sind - der
     Schnappschuss kennt bei 10014 einen Zuckerwert, den Shopify nicht
     hat, und beim Honig einen Salzwert.

     Quelle: die Metafelder custom.nutrition_* am Produkt, abgelesen
     am 29.08.2026. Das sind die Angaben vom Etikett des Erzeugers.
     Reihenfolge je Zeile: kcal, Fett, davon gesaettigt,
     Kohlenhydrate, Eiweiss - je 100 g bzw. 100 ml.
     ============================================================ */
  var NW_NEU = {
    '10021':[837,93,13,0,0],
    '10020':[900,100,12,0,0],
    '10013':[320,0.2,0,79,0.3],
    '10003':[320,0.2,0,79,0.3],
    '10001':[320,0.2,0,79,0.3],
    '10000':[321,21,7.5,0,33],
    '10009':[320,0.2,0,79,0.3],
    '10004':[320,0.2,0,79,0.3],
    '10002':[320,0.2,0,79,0.3],
    '10019':[837,93,13,0,0],
    '10018':[240,0,0,40,0],
    '10017':[837,93,13,0,0],
    '10016':[837,93,13,0,0],
    '10012':[379,27,10,0,34],
    '10010':[321,21,7.5,0,33],
    '10007':[321,21,7.5,0,32],
    '10015':[351,23,8,1.9,34],
    '10028':[496,26,15,52,6.7],
    '10029':[207,0,0,46.7,0],
    '10030':[300,0,0,66.7,0],
    '10031':[239,0,0,56,1.1],
    '10036':[188,0,0,44,0.8],
    '10032':[320,0,0,75,0.9],
    '10033':[267,0,0,60,0.2],
    '10042':[362,15,9.2,49,6],
    '10043':[226,0.17,0.7,53.9,1.3],
    '10051':[634,56.7,9.5,1.8,21.9],
    '10052':[634,56.7,9.5,1.8,21.9],
    '10053':[634,56.7,9.5,1.8,21.9],
    '10054':[634,56.7,9.5,1.8,21.9],
    '10056':[300,0,0,66.7,0],
    '10058':[524,38.2,3.6,1.9,18.2],
    '10059':[485,31.1,3.3,5.2,18.7],
    '10060':[580,5.8,null,61,13],
    '10064':[634,56.7,9.5,1.8,21.9],
    '10063':[634,56.7,9.5,1.8,21.9],
    '10067':[295,0.2,0,68.3,1.8],
    '10069':[328,1.2,0.49,84.7,7.2],
    '10070':[358,0.4,0.1,80.4,2.6],
    '10071':[325,2.7,0.5,55,12],
    '10072':[257,1.8,0.6,52.4,4.3],
    '10073':[328,2.4,0.5,67.1,3.2],
    '10074':[378,18.9,2.4,42.3,10],
    '10075':[369,15.7,3.6,50.2,6.5],
    '10076':[372,11.7,7.1,60.1,3.3],
    '10129':[349,8.3,3.5,62,3],
    '10128':[752,71,11,13,8],
    '10127':[595,42.2,9.63,30.5,17.5],
    '10126':[685,62.5,6.7,10.6,17],
    '10125':[631,56.4,7.4,11.7,17.9],
    '10078':[220,0.1,0.1,30,0.1],
    '10083':[218,0,0,50,0.3],
    '10091':[649,53.1,19.4,29.3,11.5],
    '10153':[649,53.1,19.4,29.3,11.5],
    '10101':[98,0,null,0,0],
    '10106':[98,null,null,null,null],
    '10107':[828,92,16,0,0],
    '10108':[828,92,16,0,0],
    '10240':[691,72,6.2,14,9.2],
    '10123':[569,36,8.3,56,6],
    '10134':[298,3.1,1.1,30.8,21.5],
    '10135':[312,3.7,1.3,19.6,33.8],
    '10138':[312,3.7,1.3,19.6,33.8],
    '10171':[200,0.01,0.01,22.5,0.01],
    '10170':[200,0.01,0.01,22.5,0.01],
    '10165':[647,53,6.8,23,20],
    '10169':[594,50,6.21,23,18],
    '10167':[647,53,6.8,23,20],
    '10168':[645,53,6.4,19,24],
    '10172':[211,21,3.9,0,1.6],
    '10185':[619,50.3,8.1,7.4,30.1],
    '10245':[315,10,0.9,38.4,14],
    '10248':[326,11.1,0.9,38,12.6],
    '10251':[349,13,1.4,39,14],
    '10254':[335,12.9,0.9,39.6,13.2],
    '10257':[348,12.5,1.2,40,12.2],
    '10263':[304,0.39,0,73.8,1.5]
  };
  var ZUCKER_NEU = {
    '10015':1.7,'10018':40,'10019':0,'10020':0,'10021':0,'10000':0,'10010':0,'10012':0,
    '10016':0,'10017':0,'10028':46,'10029':40,'10030':60,'10031':48,'10032':74,'10033':60,
    '10036':43,'10042':26,'10043':41.9,'10051':1.8,'10052':1.8,'10053':1.8,'10054':1.8,
    '10056':60,'10058':1.5,'10059':0.5,'10063':1.8,'10064':1.8,'10067':66.5,'10069':74,
    '10070':67.6,'10071':50,'10072':36.5,'10073':67.1,'10074':39.9,'10075':47.2,'10076':54.7,
    '10078':10,'10083':39,'10091':24.4,'10101':0,'10107':0,'10108':0,'10123':53.8,'10125':5.2,
    '10126':6.9,'10127':9,'10128':6,'10129':59.9,'10134':13.7,'10135':0.7,'10138':0.7,
    '10153':24.4,'10165':4.9,'10168':4.3,'10169':7.5,'10170':4,'10171':4,'10185':4,
    '10240':4,'10245':25.5,'10248':28.6,'10251':27.1,'10254':27.1,'10257':30,'10263':66.5
  };
  var FELDER = ['kcal', 'fett', 'gesaettigt', 'kohlenhydrate', 'eiweiss'];

  if (typeof NAEHRWERT !== 'undefined' && NAEHRWERT) {
    Object.keys(NW_NEU).forEach(function (sku) {
      if (!NAEHRWERT[sku]) NAEHRWERT[sku] = { quelle: 'Etikett' };
      FELDER.forEach(function (f, i) {
        if (NAEHRWERT[sku][f] == null && NW_NEU[sku][i] != null) NAEHRWERT[sku][f] = NW_NEU[sku][i];
      });
    });
    Object.keys(ZUCKER_NEU).forEach(function (sku) {
      if (!NAEHRWERT[sku]) NAEHRWERT[sku] = { quelle: 'Etikett' };
      if (NAEHRWERT[sku].zucker == null) NAEHRWERT[sku].zucker = ZUCKER_NEU[sku];
    });
  }

  function wert(sku, stoff) {
    if (typeof NAEHRWERT === 'undefined' || !NAEHRWERT[sku]) return null;
    var z = NAEHRWERT[sku][stoff];
    return (z == null) ? null : z;
  }
  function zuckerWert(sku) { return wert(sku, 'zucker'); }
  function komma(n) { return String(n).replace('.', ','); }

  /* ============================================================
     2 · Naehrwerte als Liste
     Eine Funktion fuer alle fuenf Stoffe. Kein Urteil ueber viel oder
     wenig - nur die Zahl vom Etikett. Das ist auch die Grenze der
     Health-Claim-Verordnung: eine Zahl nennen ist erlaubt, sie
     bewerten nicht.

     Zucker, Fett und Energie stehen aufsteigend, Eiweiss absteigend.
     Wer nach Eiweiss fragt, sucht den hohen Wert; wer nach Zucker
     fragt, den niedrigen. Die Reihenfolge ist keine Wertung, sondern
     die Antwort auf die Frage, die tatsaechlich gestellt wurde.
     ============================================================ */
  var STOFF = {
    zucker:        { name: 'Zucker',        einheit: 'g',    ab: true  },
    eiweiss:       { name: 'Eiweiß',        einheit: 'g',    ab: false },
    fett:          { name: 'Fett',          einheit: 'g',    ab: true  },
    kcal:          { name: 'Energie',       einheit: 'kcal', ab: true  },
    kohlenhydrate: { name: 'Kohlenhydrate', einheit: 'g',    ab: true  }
  };

  function naehrwertListe(stoff) {
    var def = STOFF[stoff];
    if (!def) return null;
    var liste = PRODUKTE.filter(function (p) { return wert(p.s, stoff) != null; })
      .sort(function (a, b) {
        return def.ab ? wert(a.s, stoff) - wert(b.s, stoff) : wert(b.s, stoff) - wert(a.s, stoff);
      });
    if (liste.length < 3) return null;
    var werte = liste.map(function (p) { return wert(p.s, stoff); });
    var min = Math.min.apply(null, werte), max = Math.max.apply(null, werte);
    var bezug = 'je 100 g';
    /* Das Beispiel fuer die Umrechnung kommt aus der Liste selbst.
       "Wie viel Eiweiss sind in 30 g Bluetenhonig" waere eine
       schlechte Frage - Honig hat praktisch keins. */
    var beispiel = (typeof kurz === 'function') ? kurz(liste[0].t) : liste[0].t;

    return {
      summary: 'Du willst den ' + def.name + '-Gehalt sehen. Die Zahl steht auf dem Etikett und wird unverändert übernommen.',
      tags: [def.name, bezug, liste.length + ' Artikel'],
      eyebrow: def.name,
      title: def.name + ' ' + bezug + ' — vom ' + (def.ab ? 'niedrigsten' : 'höchsten') + ' Wert an',
      intro: 'Jede Zahl stammt vom Etikett des Erzeugers. Artikel ohne Angabe stehen nicht in der Liste, ' +
             'geschätzt wird nichts.',
      visual: 'help',
      refine: false,
      /* pick() laeuft unmittelbar vor dem Zeichnen des Rasters. Die
         Marke sagt der Produktkarte, welche Zahl sie zusaetzlich
         zeigen soll; der Wrapper unten loescht sie bei jeder neuen
         Frage wieder. */
      pick: function () { window.kunoNaehrSpalte = stoff; return liste; },
      metrics: [
        [komma(min) + '–' + komma(max) + ' ' + def.einheit, def.name + ' ' + bezug],
        [String(liste.length), 'Artikel mit Angabe'],
        ['Etikett', 'Herkunft der Zahl']
      ],
      choice: [
        { title: def.name + ' in einer Portion', desc: 'Rechnet die Zahl auf deine Menge um.',
          ask: 'Wie viel ' + def.name + ' sind in 30 g ' + beispiel + '?' },
        { title: 'Artikel mit einer einzigen Zutat', desc: 'Kurze Zutatenliste, nichts zugesetzt.',
          ask: 'Artikel mit wenigen Zutaten' }
      ],
      source: 'Nährwertangaben der Erzeuger, Etikett bzw. Herstellerangabe im Shop.'
    };
  }

  /* ============================================================
     3 · Die vier Fachbuecher
     Bisher waren sie in keiner Antwort erreichbar. Der Grund war die
     Sorge um die Health-Claim-Verordnung - ein Buchtitel ist aber
     keine Aussage ueber ein Lebensmittel. Zitiert wird nach der
     Hausregel: Autor, Titel in Anfuehrungszeichen.

     Die Buecher stehen bewusst NICHT in PRODUKTE. Sonst zaehlten sie
     bei "vegetarisch", beim Preisvergleich und in jeder Warengruppe
     mit - ein Buch ist kein Lebensmittel.
     ============================================================ */
  var BUCH = [
    { s:'10022', k:'buch', n:'', p:15.00, lieferbar:true,
      t:'Ernährung. Meine Quintessenz | Andreas Michalsen',
      i:B + 'ernaehrung-meine-quintessenz_9783458644729_cover.webp?v=1769686185',
      url:'/products/ernahrung-meine-quintessenz' },
    { s:'10023', k:'buch', n:'', p:14.00, lieferbar:true,
      t:'Mit Ernährung heilen | Andreas Michalsen',
      i:B + 'mit-ernaehrung-heilen_9783458364665_cover.webp?v=1769608558',
      url:'/products/mit-ernahrung-heilen' },
    { s:'10025', k:'buch', n:'', p:15.00, lieferbar:true,
      t:'Heilen mit der Kraft der Natur | Andreas Michalsen',
      i:B + 'heilen-mit-der-kraft-der-natur_9783458684411_cover.webp?v=1769612319',
      url:'/products/heilen-mit-der-kraft-der-natur' },
    { s:'10024', k:'buch', n:'', p:12.95, lieferbar:true,
      t:'Die Natur-Docs — Meine besten Heilmittel für Gelenke | Andreas Michalsen',
      i:B + 'die-natur-docs-meine-besten-heilmittel-fuer-gelenke-arthrose-rheuma-und-schmerzen_9783458683346_cover.jpg?v=1769609986',
      url:'/products/die-natur-docs-meine-besten-heilmittel-fur-gelenke-arthrose-rheuma-und-schmerzen' }
  ];
  var RE_BUCH = /(^|[^a-zäöüß])(buch|bücher|buecher|kochbuch|kochbücher|fachbuch|fachbücher|lektüre|lesen|leseempfehlung|ernährungswissen|ernaehrungswissen|michalsen|autor|autoren)($|[^a-zäöüß])/;

  function buchAntwort() {
    return {
      summary: 'Du suchst etwas zum Lesen. Vier Titel stehen im Sortiment.',
      tags: ['Ernährungswissen', '4 Bücher'],
      eyebrow: 'Ernährungswissen',
      title: 'Vier Bücher zum Weiterlesen',
      intro: 'Andreas Michalsen ist Chefarzt für Naturheilkunde am Immanuel Krankenhaus Berlin und ' +
             'Professor an der Charité. Vier seiner Titel liegen im Sortiment — Preis und Verfügbarkeit ' +
             'wie bei jedem anderen Artikel.',
      visual: 'help',
      refine: false,
      pick: function () { return BUCH.slice(); },
      metrics: [],
      choice: [
        { title: 'Rezepte aus dem Magazin', desc: 'Kalt, warm, gekocht und gebacken.', ask: 'Zeig mir Rezepte' },
        { title: 'Die Erzeuger dahinter', desc: 'Elf Porträts von Höfen und Manufakturen.', ask: 'Welche Erzeuger gibt es?' }
      ],
      source: 'Andreas Michalsen: „Ernährung. Meine Quintessenz“, „Mit Ernährung heilen“, ' +
              '„Heilen mit der Kraft der Natur“, „Die Natur-Docs — Meine besten Heilmittel für Gelenke“. ' +
              'Alle im Insel Verlag erschienen.'
    };
  }

  /* ============================================================
     4 · Rezepte mischen
     41 Rezepte liegen im Magazin, 22 davon sind kalte Getraenke -
     und die standen alle vorn. Wer acht Karten sah, sah acht Eistees.
     REZEPTE wird deshalb einmalig umsortiert: an jeder Stelle der
     Liste steht jetzt eine Mischung. Gefiltert wird weiterhin ueber
     das ganze Feld, es faellt kein Rezept weg.

     Muster fuer die ersten acht: vier kalte, vier andere.
     ============================================================ */
  function rezepteMischen() {
    if (typeof REZEPTE === 'undefined' || !Array.isArray(REZEPTE) || REZEPTE.__gemischt) return;
    var eimer = { kalt: [], warm: [], kochen: [], backen: [] };
    REZEPTE.forEach(function (r) { (eimer[r.g] || (eimer[r.g] = [])).push(r); });

    /* Innerhalb eines Eimers zuerst die Warengruppen durchwechseln,
       damit nicht fuenf Matcha-Rezepte nebeneinander landen. */
    Object.keys(eimer).forEach(function (g) {
      var nachW = {}, reihe = [], k;
      eimer[g].forEach(function (r) { (nachW[r.w || '—'] || (nachW[r.w || '—'] = [])).push(r); });
      var gruppen = Object.keys(nachW), leer = false;
      while (!leer) {
        leer = true;
        for (k = 0; k < gruppen.length; k++) {
          if (nachW[gruppen[k]].length) { reihe.push(nachW[gruppen[k]].shift()); leer = false; }
        }
      }
      eimer[g] = reihe;
    });

    var muster = ['kalt','kalt','warm','kochen','kalt','backen','kalt','warm','kochen','backen'];
    var neu = [], i = 0, rest;
    while (neu.length < REZEPTE.length) {
      var g = muster[i % muster.length]; i++;
      if (eimer[g] && eimer[g].length) { neu.push(eimer[g].shift()); continue; }
      /* Eimer leer: nimm den vollsten der uebrigen. */
      rest = Object.keys(eimer).filter(function (x) { return eimer[x].length; });
      if (!rest.length) break;
      rest.sort(function (a, b) { return eimer[b].length - eimer[a].length; });
      neu.push(eimer[rest[0]].shift());
    }
    if (neu.length !== REZEPTE.length) return;           /* im Zweifel nichts anfassen */
    REZEPTE.length = 0;
    neu.forEach(function (r) { REZEPTE.push(r); });
    REZEPTE.__gemischt = true;
  }
  rezepteMischen();

  /* ============================================================
     5 · Einhaengen
     Reihenfolge wie in der Suchschicht: Sperrliste und Umlenkungen
     behalten Vorrang, ergaenzt wird nur da, wo sonst die
     Rueckfrage stuende.
     ============================================================ */
  /* Ein Wort je Stoff, mit Zeichenklassen-Grenzen statt \\b - das
     versagt an deutschen Komposita. NIE faengt die Teilwort-Fallen ab:
     "zuckerarm" enthaelt "zucker", meint aber etwas anderes, und
     "Fettnaepfchen" ist kein Naehrwert. */
  var NAEHR_WORT = [
    { stoff: 'zucker',
      re:  /(^|[^a-zäöüß])(zucker|zuckergehalt|zuckeranteil|zuckerwerte)($|[^a-zäöüß])/,
      nie: /zuckerfrei|zuckerarm|zuckerrübe|zuckerrohr|zuckerguss|zuckerwatte|zuckererbse/ },
    { stoff: 'eiweiss',
      re:  /(^|[^a-zäöüß])(eiweiß|eiweiss|eiweißgehalt|protein|proteine|proteingehalt)($|[^a-zäöüß])/,
      nie: /eiweißschnee|eischnee/ },
    { stoff: 'fett',
      re:  /(^|[^a-zäöüß])(fett|fettgehalt|fettanteil|fettwerte)($|[^a-zäöüß])/,
      nie: /fettnäpfchen|fettarm|fettfrei|fettsäure/ },
    { stoff: 'kcal',
      re:  /(^|[^a-zäöüß])(kalorien|kalorie|kcal|brennwert|energiegehalt|energiewert)($|[^a-zäöüß])/,
      nie: /kalorienarm|kalorienfrei/ },
    { stoff: 'kohlenhydrate',
      re:  /(^|[^a-zäöüß])(kohlenhydrat|kohlenhydrate|kohlenhydraten)($|[^a-zäöüß])/,
      nie: /kohlenhydratarm|low.?carb/ }
  ];
  var RE_VERGLEICH_OEL = /vergleich/;
  var RE_OEL = /(^|[^a-zäöüß])(öl|öle|ölen|olivenöl|olivenöle|olivenölen)($|[^a-zäöüß])/;

  if (typeof classifyVoll === 'function') {
    var alt = classifyVoll;
    classifyVoll = function (text) {
      var s = String(text == null ? '' : text).toLowerCase().trim();
      /* Die Naehrwert-Marke gilt genau fuer eine Antwort. Ohne dieses
         Loeschen zeigte die naechste Liste noch die Zuckerzahlen der
         vorigen. */
      window.kunoNaehrSpalte = null;
      var r = alt(text);
      if (!r) return r;
      if (r.redirect) return r;

      /* Gesperrtes und Krankheitsfragen bleiben unberuehrt. */
      if (typeof results !== 'undefined' &&
          (r === results.blocked || r === results.krankheit ||
           r === results.longevity || r === results.gesund)) return r;

      /* Die Rueckfrage "Was ist dir wichtiger?" wird zuerst ueber die
         Identitaet erkannt. Der Titelvergleich ist die zweite Spur:
         faellt die Identitaet einmal weg, weil eine Schicht darunter
         eine Kopie zurueckgibt, bleibt die Ergaenzung trotzdem
         erreichbar. Beides trifft nur Anfragen, die ohnehin ohne
         Antwort dastehen. */
      var istGeneric = (typeof results !== 'undefined') && r === results.generic;
      if (!istGeneric && r.noProduct &&
          String(r.title || '').indexOf('Was ist dir wichtiger') === 0) istGeneric = true;
      /* Nur einspringen, wo unten keine Antwort steht. Alles, was
         bereits eine Liste, eine Rechnung oder einen Vergleich
         liefert, bleibt genau so. */
      if (!istGeneric) return r;

      if (RE_BUCH.test(s)) return buchAntwort();
      for (var i = 0; i < NAEHR_WORT.length; i++) {
        var w = NAEHR_WORT[i];
        if (w.re.test(s) && !w.nie.test(s)) {
          var n = naehrwertListe(w.stoff); if (n) return n;
          break;
        }
      }
      if (RE_VERGLEICH_OEL.test(s) && RE_OEL.test(s)) {
        var o = alt('Welches Olivenöl ist am kräftigsten');
        if (o && o.pick && o.pick().length > 1) return o;
      }
      return r;
    };
  }

  window.kunoNaehrwert = wert;
  window.kunoZuckerWert = zuckerWert;
  window.kunoBuecher = BUCH;
})();
